$(document).on('click', '.favorite-offer-toggle-btn', function() {
  const offerId = this.dataset.offerId;
  const button = $(this);

  // 現在のパスから te/sc を判定してエンドポイントを決定
  const basePath = window.location.pathname.startsWith('/te/') ? '/te/offers/' : '/sc/offers/';
  $.ajax({
    url: `${basePath}${offerId}/toggle_favorite`,
    type: 'POST',
    headers: {
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    },
    success: function(data) {
      if (data.status === 'success') {
        button.toggleClass('off');
        const buttonText = button.find('span');
        if (buttonText.length > 0) {
          buttonText.text(button.hasClass('off') ? '気になる済み' : '気になる');
        }
      } else {
        console.error(data.message);
      }
    },
    error: function(xhr, status, error) {
      console.error('Error:', error);
    }
  });
});
